import covid_site from '../images/covid-site.png'
import cnn from '../images/cnn.jpeg'
import castor from '../images/logo_nobackground.webp'
import poet from '../images/poet.jpeg'
import hirax from '../images/hirax.jpeg'
import m83 from '../images/m83.jpg'
import trappist1 from '../images/trappist1.jpeg'

export const projectList = [
    {
        img: covid_site,
        description: "In 2021, My friend, Ayaachi Jha, and I founded a social media web application which allowed people to post and access information regarding the availability of resources like oxygen tanks, plasma, etcetera in India. It was launched during the second wave of coronavirus pandemic and after only a few weeks, the website had 700 entries in its database. Due to its popular demand, we incorporated volunteers in our project and swiftly expanded to a team of more than 15 people. We bought the domain 'www.unitedagainstcovid19.in' and hosted the website on Amazon AWS server.",
        source_code: "https://code-against-covid.github.io/covid-site/"
    },
    {
        img: trappist1,
        description: "Here, we computed estimates of the viscous dissipation in the fluid cores of the TRAPPIST-1 planets induced by mantle libration and precession. This project was supervised by Dr. Mathieu Dumberry and the paper has been submitted for review in the American Astrophysics Journal.",
        credit: "NASA/JPL-Caltech",
        source_code: "https://github.com/Dhananjhay/ResearchProjectCodeBase"
    },
    {
        img: cnn,
        credit: "NASA, ESA, and the Hubble Heritage (STScI/AURA)-ESA/Hubble Collaboration",
        description: "For my undergraduate thesis, I developed a Convolutional Neural Network model to identify stellar wind bubbles in galaxies. More specifically, it was a semantic segmentation machine learning algorithm based on the famous U-NET architecture. The model was trained on galaxy NGC 0628 (J. Watkins et al 2023 ApJL) and it achieved an accuracy of more than 91% when an Intersection Over Union (IoU) loss function was used. This project was supervised by Dr. Erik Rosolowsky.",
        source_code: "https://github.com/Dhananjhay/Undergraduate-Thesis"
    },
    {
        img: m83,
        credit: "Credits: NASA, ESA and the Hubble Heritage Team (STScI/AURA); Acknowledgment: W. Blair (STScI/Johns Hopkins University) and R. O’Connell (University of Virginia)", 
        description:"For my observational astrophysics class, I investigated the properties of giant molecular clouds (GMCs) in the molecular rich galaxy M83 (NGC 5236) in two different transitions of carbon monoxide, CO(1–0) and CO(2–1). This research project was supervised by Dr. Erik Rosolowsky.",
        thesis: "Yes"

    }
]

export const telescopeList = [
    {
        img: castor,
        credit: '',
        description: "During my time as a junior astrophysicist research officer at National Research Council of Canada (NRC), Herzberge Astrophysics Research Center, I developed a simulation software for the Cosmological Advanced Survey Telescope for Optical and uv Research (CASTOR) mission. I was responsible for full stack software development and adding new features in the Exposure Time Calculator (ETC) python package. Moreover, I developed a custom signal to noise ratio (SNR) calculator for Sersic profile galaxies for Astronomical data analysis.",
        source_code: "https://github.com/CASTOR-telescope"
    },
    {
        img: poet,
        credit: 'Illustration by D. Aguilar/Harvard-Smithsonian Center for Astrophysics',
        description: "The Photometric Observations of Exoplanet Transits (POET) is a small space telescope that is proposed to launch in 2026 for the study and detection of exoplanets. During my time at NRC, I worked on debugging and updating POET's transit simulation python package.",
        source_code: "https://github.com/jasonfrowe/poet"
    },
    {
        img: hirax,
        credit: "Cynthia Chiang",
        description: "In summer 2022, I worked with Dr. Adam Hincks in the Department of Astronomy & Astrophysics at the University of Toronto to develop a software responsible for keeping track of the analogue signal chains of the The Hydrogen Intensity and Real-time Analysis eXperiment (HIRAX), a radio interferomater capable of mapping the southern sky over a frequency range of 400-800 MHz.",
        source_code: "https://github.com/radiocosmology/padloper"
    }
]

